const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_WISHLIST_PRICE = 'shopify-wishlist-price';	
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';
const BUTTON_ACTIVE_TEXT = 'Added to wishlist';	
const BUTTON_TEXT = 'Add to wishlist';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.card-wrapper',
  wishListPageBtn: '.header__icon--wishlist',	
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
  wishListPageIcon();
});


document.addEventListener('shopify-wishlist:updated', (event) => {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
  wishListPageIcon();	
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('theme:loading:end', (event) => {	
  // console.log('theme:loading:end', event.detail);	
  setTimeout(function(){initButtons();},1000);	
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `${handle}&view=wishlist`;
  // console.log('productTileTemplateUrl:', productTileTemplateUrl); // Output the value of productCard
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCardWrapper = document.createElement('div');	
    productCardWrapper.className="grid__item";
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
        //  console.log('productCard:', productCard); // Output the value of productCard
    productCardWrapper.appendChild(productCard);	
    return productCardWrapper.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  var counterText = wishlist.length + (( wishlist.length != 1 ) ? ' Produkte' : ' Produkt');	
  document.querySelector('.products-counter').innerText = counterText;
  
  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};


      
	const setupButtons = (buttons) => {	
  buttons.forEach((button) => {	
    const productHandle = button.dataset.productHandle || false;	
    const productPrice = button.dataset.productPrice || 0;	
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');	
    if (wishlistContains(productHandle)) {	
        button.classList.add(BUTTON_ACTIVE_CLASS);	
    }	
    button.addEventListener('click', () => {
      const productHandle = button.dataset.productHandle || false;
      const productPrice = button.dataset.productPrice || 0;
      if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
      updateWishlist(productHandle, productPrice);
      const isActive = wishlistContains(productHandle);
      if (isActive) {
        button.classList.add(BUTTON_ACTIVE_CLASS);
      } else {
        button.classList.remove(BUTTON_ACTIVE_CLASS);
      }
    });
  });
};

  
const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const wishListPageIcon = () => {	
  const wishListBtn = document.querySelector(selectors.wishListPageBtn) || false;	
  const wishlist = getWishlist();	
  if (wishListBtn){	
    if(wishListBtn.classList.contains(BUTTON_ACTIVE_CLASS) && wishlist.length == 0){	
      wishListBtn.classList.remove(BUTTON_ACTIVE_CLASS);	
    }else if(!wishListBtn.classList.contains(BUTTON_ACTIVE_CLASS) && wishlist.length > 0){	
      wishListBtn.classList.add(BUTTON_ACTIVE_CLASS);	
    }	
  }	
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
    if(!wishlist.length)	
    return [];	
  return wishlist.split(LOCAL_STORAGE_DELIMITER);	
};	
const getWishlistPrice = () => {	
  const wishlistPrice = localStorage.getItem(LOCAL_STORAGE_WISHLIST_PRICE) || false;	
  if (wishlistPrice) return wishlistPrice.split(LOCAL_STORAGE_DELIMITER);	
  return [];	
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

	const setWishlistPrice = (array) => {	
  const wishlistPrice = array.join(LOCAL_STORAGE_DELIMITER);	
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_PRICE, wishlistPrice);	
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_PRICE);	
  return wishlistPrice;	
};	
const updateWishlist = (handle, price) => {	
  const wishlist = getWishlist();	
  const wishlistPrice = getWishlistPrice();	
  const indexInWishlist = wishlist.indexOf(handle);	
  if (indexInWishlist === -1) {	
    wishlist.push(handle);	
    wishlistPrice.push(price);	
  }	
  else {	
    wishlist.splice(indexInWishlist, 1);	
    wishlistPrice.splice(indexInWishlist, 1);	
  }	
  setWishlistPrice(wishlistPrice);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

